var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M504.001,512.001h-496c-4.418,0-8-3.582-8-8v-496c0-4.418,3.582-8,8-8h496c4.418,0,8,3.582,8,8v496  C512.001,508.419,508.419,512.001,504.001,512.001z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M512.001,404.212c-25.628,0-25.628-13.474-51.257-13.474c-25.628,0-25.628,13.474-51.257,13.474   c-25.611,0-25.611-13.474-51.221-13.474c-25.588,0-25.588,13.474-51.177,13.474c-25.602,0-25.602-13.474-51.205-13.474   c-25.596,0-25.596,13.474-51.191,13.474s-25.595-13.474-51.191-13.474c-25.595,0-25.595,13.474-51.191,13.474   c-25.584,0-25.584-13.474-51.168-13.474c-25.572,0-25.572,13.474-51.143,13.474v-40.421c25.572,0,25.572-13.474,51.143-13.474   c25.584,0,25.584,13.474,51.168,13.474c25.595,0,25.595-13.474,51.191-13.474c25.595,0,25.595,13.474,51.191,13.474   s25.596-13.474,51.191-13.474c25.602,0,25.602,13.474,51.205,13.474c25.588,0,25.588-13.474,51.177-13.474   c25.611,0,25.611,13.474,51.221,13.474c25.628,0,25.628-13.474,51.257-13.474c25.628,0,25.628,13.474,51.257,13.474V404.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M512.001,242.527c-25.628,0-25.628-13.474-51.257-13.474c-25.628,0-25.628,13.474-51.257,13.474   c-25.611,0-25.611-13.474-51.221-13.474c-25.588,0-25.588,13.474-51.177,13.474c-25.602,0-25.602-13.474-51.205-13.474   c-25.596,0-25.596,13.474-51.191,13.474s-25.595-13.474-51.191-13.474c-25.595,0-25.595,13.474-51.191,13.474   c-25.584,0-25.584-13.474-51.168-13.474c-25.572,0-25.572,13.474-51.143,13.474v-40.421c25.572,0,25.572-13.474,51.143-13.474   c25.584,0,25.584,13.474,51.168,13.474c25.595,0,25.595-13.474,51.191-13.474c25.595,0,25.595,13.474,51.191,13.474   s25.596-13.474,51.191-13.474c25.602,0,25.602,13.474,51.205,13.474c25.588,0,25.588-13.474,51.177-13.474   c25.611,0,25.611,13.474,51.221,13.474c25.628,0,25.628-13.474,51.257-13.474c25.628,0,25.628,13.474,51.257,13.474V242.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M512.001,161.685c-25.628,0-25.628-13.474-51.257-13.474c-25.628,0-25.628,13.474-51.257,13.474   c-25.611,0-25.611-13.474-51.221-13.474c-25.588,0-25.588,13.474-51.177,13.474c-25.602,0-25.602-13.474-51.205-13.474   c-25.596,0-25.596,13.474-51.191,13.474s-25.595-13.474-51.191-13.474c-25.595,0-25.595,13.474-51.191,13.474   c-25.584,0-25.584-13.474-51.168-13.474c-25.572,0-25.572,13.474-51.143,13.474v-40.421c25.572,0,25.572-13.474,51.143-13.474   c25.584,0,25.584,13.474,51.168,13.474c25.595,0,25.595-13.474,51.191-13.474c25.595,0,25.595,13.474,51.191,13.474   s25.596-13.474,51.191-13.474c25.602,0,25.602,13.474,51.205,13.474c25.588,0,25.588-13.474,51.177-13.474   c25.611,0,25.611,13.474,51.221,13.474c25.628,0,25.628-13.474,51.257-13.474c25.628,0,25.628,13.474,51.257,13.474V161.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M512.001,80.843c-25.628,0-25.628-13.474-51.257-13.474c-25.628,0-25.628,13.474-51.257,13.474   c-25.611,0-25.611-13.474-51.221-13.474c-25.588,0-25.588,13.474-51.177,13.474c-25.602,0-25.602-13.474-51.205-13.474   c-25.596,0-25.596,13.474-51.191,13.474s-25.595-13.474-51.191-13.474c-25.595,0-25.595,13.474-51.191,13.474   c-25.584,0-25.584-13.474-51.168-13.474c-25.57,0-25.57,13.474-51.142,13.474V40.422c25.572,0,25.572-13.474,51.143-13.474   c25.584,0,25.584,13.474,51.168,13.474c25.595,0,25.595-13.474,51.191-13.474c25.595,0,25.595,13.474,51.191,13.474   s25.596-13.474,51.191-13.474c25.602,0,25.602,13.474,51.205,13.474c25.588,0,25.588-13.474,51.177-13.474   c25.611,0,25.611,13.474,51.221,13.474c25.628,0,25.628-13.474,51.257-13.474c25.628,0,25.628,13.474,51.257,13.474v40.421H512.001   z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M512.001,323.369c-25.628,0-25.628-13.474-51.257-13.474c-25.628,0-25.628,13.474-51.257,13.474   c-25.611,0-25.611-13.474-51.221-13.474c-25.588,0-25.588,13.474-51.177,13.474c-25.602,0-25.602-13.474-51.205-13.474   c-25.596,0-25.596,13.474-51.191,13.474s-25.595-13.474-51.191-13.474c-25.595,0-25.595,13.474-51.191,13.474   c-25.584,0-25.584-13.474-51.168-13.474c-25.572,0-25.572,13.474-51.143,13.474v-40.421c25.572,0,25.572-13.474,51.143-13.474   c25.584,0,25.584,13.474,51.168,13.474c25.595,0,25.595-13.474,51.191-13.474c25.595,0,25.595,13.474,51.191,13.474   s25.596-13.474,51.191-13.474c25.602,0,25.602,13.474,51.205,13.474c25.588,0,25.588-13.474,51.177-13.474   c25.611,0,25.611,13.474,51.221,13.474c25.628,0,25.628-13.474,51.257-13.474c25.628,0,25.628,13.474,51.257,13.474V323.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M512.001,485.054c-25.628,0-25.628-13.474-51.257-13.474c-25.628,0-25.628,13.474-51.257,13.474   c-25.611,0-25.611-13.474-51.221-13.474c-25.588,0-25.588,13.474-51.177,13.474c-25.602,0-25.602-13.474-51.205-13.474   c-25.596,0-25.596,13.474-51.191,13.474s-25.595-13.474-51.191-13.474c-25.595,0-25.595,13.474-51.191,13.474   c-25.584,0-25.584-13.474-51.168-13.474c-25.572,0-25.572,13.474-51.143,13.474v-40.421c25.572,0,25.572-13.474,51.143-13.474   c25.584,0,25.584,13.474,51.168,13.474c25.595,0,25.595-13.474,51.191-13.474c25.595,0,25.595,13.474,51.191,13.474   s25.596-13.474,51.191-13.474c25.602,0,25.602,13.474,51.205,13.474c25.588,0,25.588-13.474,51.177-13.474   c25.611,0,25.611,13.474,51.221,13.474c25.628,0,25.628-13.474,51.257-13.474c25.628,0,25.628,13.474,51.257,13.474V485.054z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965032"
    },
    d: "M396.231,461.93h-3.293c-3.059,0-5.538-2.479-5.538-5.538V224.841h14.369v231.551  C401.769,459.45,399.289,461.93,396.231,461.93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "495.167,253.579 480.798,246.394 427.894,239.782 460.627,197.696 465.707,182.456   450.467,187.536 408.382,220.268 401.769,167.365 394.584,152.996 387.4,167.365 380.787,220.268 338.702,187.536 323.461,182.456   328.541,197.696 361.274,239.782 308.37,246.394 294.001,253.579 308.37,260.764 361.274,267.376 328.541,309.461 323.461,324.702   338.702,319.622 384.424,284.061 394.584,267.948 404.744,284.061 450.467,319.622 465.707,324.702 460.627,309.461   427.894,267.376 480.798,260.764 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M425.862,337.253c-6.457-6.444-20.283-4.076-27.686-2.207v-6.03c0-1.984-1.608-3.592-3.592-3.592  s-3.592,1.608-3.592,3.592v6.029c-7.402-1.875-21.226-4.243-27.686,2.208c-6.158,6.155-1.697,20.996,2.54,31.313v9.553  c0,2.641,2.14,4.781,4.781,4.781h47.915c2.64,0,4.781-2.14,4.781-4.781v-9.553C427.559,358.249,432.02,343.408,425.862,337.253z   M420.782,342.333c2.742,2.745-0.329,14.775-5.278,26.198h-17.328v-26.065C406.242,340.183,417.29,338.834,420.782,342.333z   M368.386,342.333c3.49-3.499,14.538-2.15,22.606,0.134v26.064h-17.328C368.715,357.108,365.644,345.078,368.386,342.333z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.317,0.001 0.001,0.001 0.001,19.978 94.317,81.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0.001,68.3 0.001,94.317 39.711,94.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0.001,161.685 0.001,187.702 39.711,161.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256.001,19.978 256.001,0.001 161.685,0.001 161.685,81.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256.001,187.702 256.001,161.685 216.291,161.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.685,174.231 161.685,256.001 256.001,256.001 256.001,236.024  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256.001,94.317 256.001,68.3 216.291,94.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0.001,236.024 0.001,256.001 94.317,256.001 94.317,174.231  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256.001,236.024 256.001,216.06 172.233,161.685 196.981,161.685 256.001,199.996    256.001,187.702 216.291,161.685 256.001,161.685 256.001,148.211 148.212,148.211 148.212,256.001 161.685,256.001    161.685,174.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0.001,148.211 0.001,161.685 39.711,161.685 0.001,187.702 0.001,206.603 69.198,161.685    93.946,161.685 0.001,222.667 0.001,236.024 94.317,174.231 94.317,256.001 107.79,256.001 107.79,148.211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.79,0.001 94.317,0.001 94.317,81.771 0.001,19.978 0.001,41.84 80.843,94.317    56.095,94.317 0.001,57.905 0.001,68.3 39.711,94.317 0.001,94.317 0.001,107.791 107.79,107.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256.001,107.791 256.001,94.317 216.291,94.317 256.001,68.3 256.001,49.158    186.433,94.317 161.685,94.317 256.001,33.094 256.001,19.978 161.685,81.771 161.685,0.001 148.212,0.001 148.212,107.791  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256.001,148.211 256.001,107.791 148.212,107.791 148.212,0.001 107.79,0.001    107.79,107.791 0.001,107.791 0.001,148.211 107.79,148.211 107.79,256.001 148.212,256.001 148.212,148.211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.198,161.685 0.001,206.603 0.001,222.667 93.946,161.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.233,161.685 256.001,216.06 256.001,199.996 196.981,161.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.843,94.317 0.001,41.84 0.001,57.905 56.095,94.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.433,94.317 256.001,49.158 256.001,33.094 161.685,94.317  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/IO.59a62baae23f5139ef37c9215673d6ea.svg";
export { ForwardRef as ReactComponent };